import { createContext } from "react";

export const OdysseeContext = createContext(null);
